import React from 'react'
import { Box, ListItemButton, Typography } from '@mui/material'
import {
  Article,
  ChartLine,
  ChatCircle,
  Megaphone,
  Trophy
} from '@phosphor-icons/react'
import { useStyles } from './style'
import { NOTIFICATION_TYPE, formatTimeAgo } from './constants'

const ICON_SIZE = 20

const ICON_BY_TYPE = {
  [NOTIFICATION_TYPE.CONTENT]: Article,
  [NOTIFICATION_TYPE.FEATURE]: Megaphone,
  [NOTIFICATION_TYPE.DIGEST]: ChartLine,
  [NOTIFICATION_TYPE.MENTION]: ChatCircle,
  [NOTIFICATION_TYPE.ACHIEVEMENT]: Trophy
}

export const NotificationItem = ({ notification, onClick, dataTest }) => {
  const classes = useStyles()
  const { type, title, body, createdAt, read } = notification
  const Icon = ICON_BY_TYPE[type] || Article
  const timeAgo = formatTimeAgo(createdAt)

  return (
    <ListItemButton
      // `li` keeps the parent <List> a valid ul>li tree, so screen readers
      // announce the list with an accurate item count (PENG-2492 bar).
      component='li'
      className={`${classes.item} ${read ? '' : classes.itemUnread}`}
      onClick={onClick}
      data-test={dataTest}
    >
      <Box className={classes.avatar} aria-hidden='true'>
        <Icon size={ICON_SIZE} weight='duotone' />
      </Box>

      <Box className={classes.itemBody}>
        <Typography className={classes.itemTitle}>{title}</Typography>
        {body && (
          <Typography className={classes.itemSubtitle}>{body}</Typography>
        )}
      </Box>

      <Box className={classes.itemMeta}>
        {/* `time` + `dateTime` so the compact "2h" has a machine-readable
            timestamp behind it, and the full date on hover. */}
        <Typography
          component='time'
          dateTime={createdAt}
          title={createdAt ? new Date(createdAt).toLocaleString() : undefined}
          className={classes.timeAgo}
        >
          {timeAgo}
        </Typography>
        {read
          ? <Box className={classes.unreadDotPlaceholder} aria-hidden='true' />
          : (
            <>
              <Box className={classes.unreadDot} aria-hidden='true' />
              {/* Unread is carried by this word, never by the dot's colour alone. */}
              <Box component='span' className={classes.srOnly}>Unread</Box>
            </>
            )}
      </Box>
    </ListItemButton>
  )
}

export default NotificationItem
